import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getAccidentsWithFilters } from "../../../../../actions/accidents";
import { openNewForm, setFormsGeneralProperties } from "../../../../../actions/formsState";
import { signoutUser } from "../../../../../actions/login";
import { changeSelectProvider } from "../../../../../actions/providers";
import LoadingComponent from "../../../../commons/loadingData/loading";
import FormContainer from "../../formContainer";


const AuthorizedResponsiveFormContainer = () => {
  const { data, isFetching } = useSelector((state) => state.forms.formDecryptUrl);
  const { didInvalidateFilter } = useSelector((state) => state.accidents);
  const { selectedProvider } = useSelector((state) => state.providers);
  const { open: openForm } = useSelector((state) => state.formsState);
  const userName = useSelector((state) => state.auth.userName);
  const { encryptedParameters: routeEncryptedParameters } = useParams();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    if (!isFetching && userName !== "") {
      if (data?.encryptedParameters !== routeEncryptedParameters) {
        // Obtenemos el nuevo usuario / parametros desde public.
        dispatch(signoutUser());
      } else {
        if (data?.providerId !== selectedProvider) {
          dispatch(changeSelectProvider(data.providerId));
        }
        const searchParams = {
          wri: data.wriId,
          accidentId: data.accidentId
        };
        dispatch(getAccidentsWithFilters(new URLSearchParams(searchParams).toString())).then((data) => {
          if (!isMounted) return;
          const accident = data.value.data.accidents?.[0];
          dispatch(
            setFormsGeneralProperties({
              idSiniestro: accident.idSiniestro,
              idArt: accident.mlCloudCoreArtId,
              artName: accident.art,
              documento: accident.documento,
              trabajador: accident.trabajador ?? accident.apellidoTrabajador + ' ' + accident.nombreTrabajador,
              apellidoTrabajador: accident.apellidoTrabajador,
              nombreTrabajador: accident.nombreTrabajador,
              numeroHistoriaClinica: accident.siniestro,
            }),
          );
          dispatch(openNewForm("Idr", "Informes / Doc. Respaldatoria"));
          setLoading(false);
        })
      }
    }
    return () => {
      isMounted = false;
    }
  }, [isFetching, userName, routeEncryptedParameters, data]);

  if (!loading && !openForm) {
    return <LoadingComponent finishLoadingText="Se envió el formulario correctamente." />
  }

  if (loading || !openForm) {
    return <LoadingComponent finishLoadingText={didInvalidateFilter ? "No se pudo obtener el siniestro para el cual quiere agregar un formulario." : undefined} />
  }

  return (

    <FormContainer isDialog={false} />

  )

};


export default AuthorizedResponsiveFormContainer;